import {Component, OnInit} from '@angular/core';
import Map from '@arcgis/core/Map';
import MapView from '@arcgis/core/views/MapView';
import ZoomViewModel from '@arcgis/core/widgets/Zoom/ZoomViewModel';
import FeatureLayer from '@arcgis/core/layers/FeatureLayer';
// import PopupTemplate from 'esri/PopupTemplate';
// import {config} from 'rxjs';
import {environment} from '../../environments/environment';
import esriConfig from '@arcgis/core/config';
import { addProxyRule } from '@arcgis/core/core/urlUtils';
import {NgIf} from '@angular/common';
import {HelpDocsLinksComponent} from '@shared/help-docs-links/help-docs-links.component';

@Component({
    selector: 'app-dashboard-map',
    templateUrl: './dashboard-map.component.html',
    imports: [
        HelpDocsLinksComponent,
        NgIf
    ],
    styleUrls: ['./dashboard-map.component.css']
})
export class DashboardMapComponent implements OnInit {
  mapLoading = true;
  map: __esri.Map;
  view: __esri.MapView;
  zoomView: __esri.ZoomViewModel;

  constructor() {
  }

  ngOnInit() {
    // parser.parse();

    this.map = new Map({
      basemap: 'satellite'
    });

    this.view = new MapView({
      map: this.map,
      container: 'mapDiv',
      ui: {components: []}
    });

    this.zoomView = new ZoomViewModel({view: this.view});

    this.view.when(() => {
      this.mapLoading = false;
      this.view.goTo({
        center: environment.default_map_center,
        zoom: 11,
      });

    });

    // const basemap = new TileLayer(environment.baseMapService);
    // this.map.layers.add(basemap);

//    var bspMapLayer = new ArcGISDynamicMapServiceLayer("http://maps.guam.gov/ArcGIS/rest/services/Environmental/MapServer");

    // const popup = new PopupTemplate({
    //   title: '<a href=\'/site/{GLOBALID}\' title=\'Go to site record\'>{Name}</a>',
    //   description: "{StreetAddress}, {Village}"
    // });

    const featureLayer = new FeatureLayer({
      url: environment.sitesService,
      outFields: ['*'],
      // infoTemplate: popup
    });

    this.map.layers.add(featureLayer);

//    bspMapLayer.setVisibleLayers([0,1,2,3,4,5,6,7,8,9,10,11,14,16]);

  }


  public zoomIn() {
    this.zoomView.zoomIn();
  }

  public zoomOut() {
    this.zoomView.zoomOut();
  }

}
